import { Link } from 'react-router-dom';

const BASE = import.meta.env.BASE_URL || '/';

const colors = {
  mintLight: '#b8e4dd',
  mint: '#7ECEC1',
  warmGray: '#4A4543',
};

interface FooterProps {
  onContactClick?: () => void;
}

export default function Footer({ onContactClick }: FooterProps) {
  return (
    <footer className="py-16" style={{ backgroundColor: colors.mintLight }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <a
            href={BASE}
            className="flex items-center justify-center gap-4 mb-8 hover:opacity-90 transition-opacity cursor-pointer"
          >
            <div className="w-14 h-14 flex items-center justify-center">
              <img src="/images/logo-icon.png" alt="国際女性デー ロゴ" className="w-full h-full object-contain" />
            </div>
            <div
              className="flex flex-col leading-tight text-center"
              style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif" }}
            >
              <span className="text-lg sm:text-xl font-bold">国際女性デー</span>
              <span className="text-sm sm:text-base font-medium text-gray-600">チャリティイベント 2026</span>
            </div>
          </a>
          <p className="text-xl mb-8" style={{ color: colors.warmGray }}>
            愛と希望の翼で世界を変える
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 mb-10">
            {onContactClick ? (
              <button
                onClick={onContactClick}
                className="flex items-center gap-2 px-4 py-2 rounded-xl bg-[#7ECEC1] text-white font-medium hover:bg-[#6ebdb0] transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-xl" />
                <span className="text-base font-bold">お問い合わせ</span>
              </button>
            ) : (
              <Link
                to="/?open=contact"
                className="flex items-center gap-2 px-4 py-2 rounded-xl bg-[#7ECEC1] text-white font-medium hover:bg-[#6ebdb0] transition-colors"
              >
                <i className="ri-mail-line text-xl" />
                <span className="text-base font-bold">お問い合わせ</span>
              </Link>
            )}
            <a
              href="https://japan-women-foundation.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-5 py-3 rounded-full bg-white transition-all hover:scale-105 hover:shadow-md"
              style={{ color: colors.warmGray }}
            >
              <img src="/images/japan-women-foundation.png" alt="日本女性財団" className="w-10 h-10 object-contain" />
              <span className="text-base font-bold">一般財団法人 日本女性財団</span>
            </a>
          </div>
          <div className="pt-8" style={{ borderTop: `1px solid ${colors.mint}40` }}>
            <p className="text-base" style={{ color: `${colors.warmGray}aa` }}>
              © 2026 日本女性財団 国際女性デー実行委員会. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
